import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const ScheduleV1 = () => {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);

  const IMAGE_BASE_URL =
    "https://eventscons.com/eventbackendnew/storage/app/public/";

  const truncateWords = (text, wordLimit = 6) => {
    if (!text) return "";
    const words = text.trim().split(/\s+/);
    if (words.length <= wordLimit) return text;
    return words.slice(0, wordLimit).join(" ") + "......";
  };

  useEffect(() => {
    const fetchEvents = async () => {
      try {
        const response = await fetch(
          "https://eventscons.com/eventbackendnew/api/conferences/details"
        );
        const result = await response.json();

        const conferenceData = Array.isArray(result?.data)
          ? result.data
          : Array.isArray(result)
          ? result
          : [];

        const upcomingEvents = conferenceData
          .filter((item) => item.status === "upcoming")
          .map((item, index) => ({
            id: item.id || index + 1,
            title: item.title,
            image: item.image ? `${IMAGE_BASE_URL}${item.image}` : "",
            description: item.description,
            start_date: item.start_date,
            end_date: item.end_date,
            status: item.status,
          }));

        setEvents(upcomingEvents);
      } catch (error) {
        console.error("Error fetching conferences:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchEvents();
  }, []);

  return (
    <>
      <style>
        {`
          .events-grid {
            display: grid;
            grid-template-columns: repeat(3, 1fr);
            gap: 25px;
          }

          @media (max-width: 767px) {
            .events-grid {
              grid-template-columns: repeat(1, 1fr);
            }

            .events-heading {
              font-size: 30px !important;
            }
          }
        `}
      </style>

      <section style={{ background: "#fff", padding: "80px 0" }}>
        <div style={{ width: "90%", margin: "auto" }}>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: "40px",
              flexWrap: "wrap",
            }}
          >
            <div>
              <h2
                className="mainheadingfont events-heading"
                style={{
                  fontSize: "42px",
                  textAlign: "left",
                  fontWeight: "700",
                  margin: 0,
                }}
              >
                Upcoming <span style={{ color: "#b11226" }}>Events</span>
              </h2>

              <p
                className="mainparafont"
                style={{
                  maxWidth: "600px",
                  fontSize: "15px",
                  marginTop: "10px",
                  color: "#000",
                }}
              >
                Exciting moments are on the way—stay tuned for what’s coming next!
Don’t miss out on our upcoming events filled with fun, learning, and great experiences.
              </p>
            </div>

            <Link
              to="/up/event"
              style={{
                background: "#000",
                color: "#fff",
                padding: "10px 30px",
                textDecoration: "none",
                fontWeight: "600",
                marginTop: "10px",
              }}
            >
              View All
            </Link>
          </div>

          {loading ? (
            <p>Loading...</p>
          ) : (
            <div className="events-grid">
              {events.map((event) => (
                <a href={`/conference/details/${event.id}`}>
                <div key={event.id} style={{ background: "#fff" }}>
                  
                  <div style={{ position: "relative" }}>
                    <img
                      src={event.image}
                      alt={event.title}
                      style={{
                        width: "100%",
                        height: "260px",
                        objectFit: "cover",
                        borderRadius: "4px",
                      }}
                    />

                    <div
                      style={{
                        position: "absolute",
                        top: "15px",
                        left: "15px",
                        background: "#fff",
                        padding: "6px 14px",
                        borderRadius: "20px",
                        fontSize: "14px",
                      }}
                    >
                      {new Date(event.start_date).toLocaleDateString("en-GB", {
                        day: "2-digit",
                        month: "short",
                      })}
                    </div>

                    <div
                      style={{
                        position: "absolute",
                        top: "15px",
                        left: "95px",
                        background: "rgba(255,255,255,0.6)",
                        padding: "6px 14px",
                        borderRadius: "20px",
                        fontSize: "14px",
                        textTransform: "capitalize",
                      }}
                    >
                      {event.status}
                    </div>
                  </div>
                  

                  <div style={{ padding: "20px" }}>
                    <h3
                      style={{
                        fontSize: "22px",
                        fontWeight: "700",
                        margin: 0,
                      }}
                    >
                      {event.title}
                    </h3>

                    <p style={{ color: "#000", marginTop: "8px" }}>
                      {truncateWords(event.description, 6)}
                    </p>
                  </div>
                </div>
                </a>
              ))}
            </div>
          )}
        </div>
      </section>
    </>
  );
};

export default ScheduleV1;